import {useEffect, useState} from "react";
import {Button} from "@mui/material";
import {Dialog2} from "../../misc/Dialog2";
import {PriceLookup} from "./PriceLookup";
import useWindowSize from "react-use/lib/useWindowSize";
import {PopperZIndexProvider} from "../../misc/scroller/PopperZIndexProvider";

export function PriceLookupHotkeyPopup() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const callback = (e) => {
            if(e.key === "L" && e.shiftKey && e.ctrlKey) {
                setShow(true);
            }
        }

        document.addEventListener("keydown", callback);
        return () => document.removeEventListener("keydown", callback);
    }, []);

    const win = useWindowSize();

    if(!show) return null;

    return (
        <Dialog2 open onClose={() => setShow(false)} maxWidth="md" fullWidth>
            <div style={{
                display: "flex",
                height: win.height * 0.75,
            }}>
                <PopperZIndexProvider value={1400}>
                    <PriceLookup actions={
                        <Button onClick={() => setShow(false)}>
                            Close
                        </Button>
                    } />
                </PopperZIndexProvider>
            </div>
        </Dialog2>
    )
}